export const biBaseUrl = '/bi';
export interface BaseListParams {
  /** 开始日期，格式为 yyyy-MM-dd */
  startDate?: string;
  /** 结束日期，格式为 yyyy-MM-dd */
  endDate?: string;
  /** 当前页码，必填项 */
  current: number;
  /** 每页显示的条目数，必填项 */
  pageSize: number;
}
